import { createSlice } from "@reduxjs/toolkit";
import { SingleAlert } from "../../types/settings";

export interface AlertsListState {
  payload: SingleAlert[] | null;
}

const slice = createSlice({
  name: "alertsList",
  initialState: { payload: null } as AlertsListState,
  reducers: {
    alertsList: (state, { payload }: { payload: SingleAlert[] | null }) => {
      state.payload = payload;
    }
  }
});

export const { alertsList } = slice.actions;
export default slice.reducer;
